import { Extension } from '@tiptap/core';
import { lineHeightAttribute } from './LineHeight/lineHeightAttribute';
import { setLineHeight } from './LineHeight/lineHeightCommands';

/**
 * LineHeightExtension — line-height per paragraph/heading block.
 * Applied via toolbar dropdown, stored as node attribute, rendered as inline style.
 */
const LineHeightExtension = Extension.create({
    name: 'lineHeight',

    addGlobalAttributes() {
        return lineHeightAttribute;
    },

    addCommands() {
        return { setLineHeight };
    },
});

export default LineHeightExtension;
